import { createFileRoute } from '@tanstack/react-router';
import { S5SignalAnalysis } from '@/screens/S5SignalAnalysis/S5SignalAnalysis';
import { Route as AnalyzeRoute } from './$orgId.analyze';

export const Route = createFileRoute('/$orgId/analyze/')({
  component: AnalyzeIndex,
});

function AnalyzeIndex() {
  const { asset, t, sensors, baseline, compare } = AnalyzeRoute.useSearch();
  return (
    <S5SignalAnalysis
      asset={asset}
      t={t}
      sensors={sensors}
      baseline={baseline}
      compare={compare}
    />
  );
}
